import React from 'react';
import useRevenueStoreMonth from './RevenueStoreM';

const RevenueChartMAll = () => {
    const totalRevenue = useRevenueStoreMonth((state) => state.totalRevenue);

    return (
        <div className='font-bold text-xl py-2 font-color-4'>
            EUR {totalRevenue.toLocaleString('de-DE', {minimumFractionDigits: 0})}
        </div>
    );
};

export default RevenueChartMAll;